<template>
  <div
    :style="style"
  >
    <div
      :style="innerStyle"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Jumbotron',

  props: {
    color: {
      default: 'rgba(0, 14, 56, 0.5)',
      type: String,
    },
    height: {
      required: true,
      type: [
        Number,
        String,
      ],
    },
    src: {
      default: null,
      type: String,
    },
  },

  computed: {
    innerStyle () {
      return {
        backgroundColor: this.color,
        bottom: 0,
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0,
      }
    },

    style () {
      const style = {
        height: `${this.height}px`,
        position: 'relative',
      }

      if (this.src) {
        style.backgroundImage = `url(${this.src})`
        style.backgroundPosition = 'center'
        style.backgroundSize = 'cover'
      }

      return style
    },
  },
}
</script>
